<script lang="ts" setup>
import { environmentDetector } from '@/helper/tools'
import { Environment } from '@/helper/Types'
</script>

<template>
  <span
    :class="{'environment-note-warning': environmentDetector() === Environment.PRODUCTION}"
    class="environment-note"
  >
    {{ environmentDetector() }}
  </span>
</template>

<style lang="scss" scoped>
.environment-note {
  padding: 1rem;
  right: 0;
  position: fixed;
  top: 4.5rem;
  background: white;

  &-warning {
    color: white;
    font-weight: 600;
    background: crimson;
  }
}
</style>
